module.exports = __webpack_public_path__ + "img/idea-office.eca3c38f.png";